import isArray from "lodash-es/isArray";
import isNil from "lodash-es/isNil";

import { ITaskOriginService, TaskPriority, TaskType } from "@/data/tasks";
import { IUser } from "@/data/users";

export const tasksFiltersMapper = {
  query: (v?: string | null) => v || undefined,
  types: (v?: TaskType[] | null) => (isArray<TaskType>(v) ? v : undefined),
  assignees: (v?: Array<Partial<IUser>> | null) => (isArray<Partial<IUser>>(v) ? v.map(u => u.id) : undefined),
  priorities: (v?: TaskPriority[] | null) => (isArray<TaskPriority>(v) ? v : undefined),
  withAssignee: (v?: boolean | null) => (isNil(v) ? undefined : v),
  originServices: (v?: ITaskOriginService[] | null) => (isArray<ITaskOriginService>(v) ? v.map(o => o.id) : undefined),
};
